module.exports = __webpack_public_path__ + "img/kfLogo.b46cbab3.png";